 import how_works_1 from '../../../assets/images/how_works_1.png';
// import how_works_2 from '../../../assets/images/basketball_banner_2.png';
// import how_works_3 from '../../../assets/images/how_works_3.png';
// import how_works_4 from '../../../assets/images/basketball_banner_3.png';
// import how_works_football_1 from '../../../assets/images/how_works_football_1.png';
// import how_works_football_2 from '../../../assets/images/how_works_football_2.webp';
// import how_works_football_3 from '../../../assets/images/how_works_football_3.webp';
// import how_works_football_4 from '../../../assets/images/how_works_football_4.webp';
// import how_works_football_5 from '../../../assets/images/fb-homepage.png';
import { COURT_NAME } from '../../../lib/constants/globalConstant';
// import georgia10 from '../../../assets/images/georgia10.webp';
// import georgia11 from '../../../assets/images/goergia11.webp';
// import georgia5 from '../../../assets/images/georgia5.webp';
// import georgia7 from '../../../assets/images/georgia7.webp';
import dc_4 from '../../../assets/images/davidson4.webp';
import dc_5 from '../../../assets/images/davidson5.webp';
import dc_6 from '../../../assets/images/davidson6.webp';
import dc_7 from '../../../assets/images/davidson7.webp';


const howItWorksData = [
    {
        id: 1,
        heading: "CHOOSE A ZONE",
        description: `The digital replica of ${COURT_NAME} has been divided into 16 zones, with each zone earning unique point multipliers and rewards.`,
        image: how_works_1,
    },
    {
        id: 2,
        heading: "SELECT YOUR TOKENS",
        description: "Select one or more tokens in each zone - your points are aggregated across all tokens, so the more tokens you buy, the more points you earn",
        image: dc_4,
    },
    {
        id: 3,
        heading: "SCORE POINTS",
        description: "Every action in your zone, Correct answers to in-game polls and quizzes, and published posts helps you earn points",
        image: dc_7,
    },
    {
        id: 4,
        heading: "Earn Rewards",
        description: "Celebrate every game by unlocking amazing rewards like Dinner with the Team, Sideline Passes, and more.",
         image: dc_6,
    },
]

export default howItWorksData